import React from 'react';
import { SearchIcon, BellIcon } from 'lucide-react';
interface HeaderProps {
  title: string;
  showSearch?: boolean;
  showNotifications?: boolean;
  onBack?: () => void;
}
const Logo = () => <div className="flex items-center" data-id="element-88">
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-89">
      {/* Table top surface - circle with dashed outline */}
      <circle cx="14" cy="14" r="8" stroke="#333333" strokeWidth="1.5" strokeDasharray="3 2" data-id="element-90" />
      {/* Table legs - four small lines */}
      <line x1="10" y1="19" x2="8" y2="22" stroke="#333333" strokeWidth="1.5" data-id="element-91" />
      <line x1="18" y1="19" x2="20" y2="22" stroke="#333333" strokeWidth="1.5" data-id="element-92" />
      <line x1="10" y1="9" x2="8" y2="6" stroke="#333333" strokeWidth="1.5" data-id="element-93" />
      <line x1="18" y1="9" x2="20" y2="6" stroke="#333333" strokeWidth="1.5" data-id="element-94" />
      {/* Small circle in center to represent table center */}
      <circle cx="14" cy="14" r="1.5" stroke="#333333" strokeWidth="1" data-id="element-95" />
    </svg>
    <span className="ml-2 text-xl font-bold text-gray-800" data-id="element-96">Partix</span>
  </div>;
export const Header = ({
  title,
  showSearch = false,
  showNotifications = true,
  onBack
}: HeaderProps) => {
  return <header className="border-b border-gray-300 p-4 flex items-center justify-between bg-white" data-id="element-97">
      <div className="flex items-center" data-id="element-98">
        {onBack && <button onClick={onBack} className="mr-2" data-id="element-99">
            ←
          </button>}
        {title === 'Partix' ? <Logo data-id="element-100" /> : <h1 className="text-xl font-bold text-gray-800" data-id="element-101">{title}</h1>}
      </div>
      <div className="flex items-center" data-id="element-102">
        {showSearch && <button className="p-2 mr-2" data-id="element-103">
            <SearchIcon className="h-5 w-5 text-gray-700" data-id="element-104" />
          </button>}
        {showNotifications && <button className="p-2" data-id="element-105">
            <BellIcon className="h-5 w-5 text-gray-700" data-id="element-106" />
          </button>}
      </div>
    </header>;
};